// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m_8N","inner":"styles_inner__3l1iS","right":"styles_right__3Vw_l","close":"styles_close__2RZxM","footer":"styles_footer__1vy8P"};